"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BasePlugin = (function () {
    function BasePlugin(name) {
        this.name = name;
    }
    BasePlugin.prototype.afterComplete = function (ref) { };
    BasePlugin.prototype.afterError = function (ref, error) { };
    BasePlugin.prototype.afterNext = function (ref, value) { };
    BasePlugin.prototype.afterSubscribe = function (ref) { };
    BasePlugin.prototype.afterUnsubscribe = function (ref) { };
    BasePlugin.prototype.beforeComplete = function (ref) { };
    BasePlugin.prototype.beforeError = function (ref, error) { };
    BasePlugin.prototype.beforeNext = function (ref, value) { };
    BasePlugin.prototype.beforeSubscribe = function (ref) { };
    BasePlugin.prototype.beforeUnsubscribe = function (ref) { };
    BasePlugin.prototype.flush = function () { };
    BasePlugin.prototype.select = function (ref) { return undefined; };
    BasePlugin.prototype.teardown = function () { };
    return BasePlugin;
}());
exports.BasePlugin = BasePlugin;
